import {BaseEntity} from "../../entities/BaseEntity";
import { StateService } from "@uirouter/angularjs";
import { ServerImportModel } from "../../models/serverimport/ServerImportModel";
import { NotificationService } from "../../services/NotificationService";

export class ServerImportUploadFileCtrl<T extends BaseEntity> {
    public content:string = "Beep";
    separator:string=",";
    result: any = "";
    public file: any;
    public static $inject = ['$q', '$scope', '$state', 'ImportModel', 'Upload', 'NotificationService'];
    constructor(public $q: ng.IQService,
        public $scope: any,
        public stateService: StateService,
        public model: ServerImportModel<T>,
        public upload: ng.angularFileUpload.IUploadService,
        public notificationService: NotificationService) {
        this.$scope.vm = this;
    }
    submit() {     
        if (this.file == null) {
            this.notificationService.notifyError("Please upload a file first.");
            return;
        }
        this.upload.upload<string>({
            url: '/api/assets/serverimportupload',
            data: { file: this.file },
            method: 'post'
        }).then((data) => {
            var fileId = data.data;
            this.model.importColumns = [];
            //next save fileId to model for processing
            this.model.fileId = fileId;
            this.$q.all([this.model.getColumns(), this.model.getImportFields()]).then((data) => {
                this.stateService.go(this.model.getRoute("mapfields"));
            }).catch((err) => {
                this.notificationService.notifyError("Failed to get columns for excel file:" + err);
            });
        })
        .catch((exc) => {
            this.notificationService.notifyError("Error in uploading import file:" + exc);
        });
    }
    updateLocation():void{
    }
}
